import React from 'react';
import { useState, useEffect, useMemo } from 'react';
import { useCallback } from 'react';

import { AllCommunityModule, ModuleRegistry, RowStyleModule, CellEditingStoppedEvent } from 'ag-grid-community'; 
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { useExportData } from './hooks/useExportData';
import { AG_GRID_LOCALE_RU } from '../common/AgGrid/locale.ru';


ModuleRegistry.registerModules([AllCommunityModule]);


function ExportTab ({schema, data, samples_letters, setSchema, setData, setIsDirty}) {
  
  const [exportData, setExportData] = useState([]);
  //const [error, setError] = useState(false)
  // Store reference to pinnedRowData
  //const pinnedRowDataDefaults = {'eas_static_row': true, 'ais_upload': true, 'name': "—"};
  const [pinnedRowData, setPinnedRowData] = useState({'eas_static_row': true, 'ais_upload': true, 'name': "—"});
  
  samples_letters = samples_letters ? samples_letters : []

  const [colDefs, setColDefs] = useState([
    
    {
      "headerName": "",
      cellRenderer: (params) => {
        if (params.data.eas_static_row === true) {
          if (params.node.rowPinned === 'bottom') {
            return (
              <button className="btn editor-button eas-static-rows mt-1"  onClick={() => addNewStaticRow(params)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="green" fill-opacity="80%" className="bi bi-plus-square-fill" viewBox="0 0 18 18">
                  <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0"/>
                </svg>
              </button>
            );
          } else {
            return (
              <button className="btn editor-button eas-static-rows"  onClick={() => deleteStaticOrExportRow(params)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" className="bi bi-x-square" viewBox="0 0 20 20">
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </svg>
              </button>
            );
          }
        }
        if (params.data.eas_static_row == undefined ) {
          if (params.data.additional_export_row === true) {
            return (
              <button className="btn editor-button additional-export-rows"  onClick={() => deleteStaticOrExportRow(params)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" className="bi bi-x-square" viewBox="0 0 20 20">
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </svg>
              </button>
            );
          } else {
            return (
              <button className="btn editor-button" style={{"backgroundColor": undefined}} onClick={() => copyExportRow(params)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-copy" viewBox="0 0 18 18">
                  <path fillRule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
                </svg>
              </button>
            )
          }
        }        
      },
      "lockPosition": 'left',
      "width": 40,
      "filter": false,
      'cellStyle': {'paddingRight': 0, 'paddingLeft': 0},
    },
    { 
      field: "ais_upload",  
      width: "130",
      cellStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
      editable: (params) => params.data.eas_static_row === undefined && params.data.additional_export_row === undefined
    },
    // Имя поля можно редактировать только одновременно с uiSchema. 
    { field: "name", flex: 2 },
    { field: "analyte",  editable: true },
    { field: "kv", editable: true },
    { 
      field: "sample", 
      editable: true,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: [null, ...samples_letters],
      } 
    },
    { field: "measure", width: "130", editable: true },      
    { field: "value", width: "130", editable: (params) => params.data.eas_static_row === true },
  ]);

  // задаем отдельные стили для eas static rows 
  const rowClassRules = useMemo(() => {
    return {
      "eas-static-rows": "data.eas_static_row === true",
      "additional-export-rows": "data.additional_export_row === true",
    };
  }, []);

  const { loadExportData, generateSchemafromTable } = useExportData()

  // Загружаем данные при изменении schema или data
  useEffect(() => {
    if (schema && data) {
      const initialExportData = loadExportData(schema, data);
      console.log('Загруженные данные таблицы:', initialExportData);
      setExportData(initialExportData);
    }
  }, [schema, data, loadExportData]);


  const copyExportRow = (params) => {

    params.api.applyTransaction({ add: [params.data] });

    const updatedData = [];
    params.api.forEachNode((node) => {
      if (node.data) {
        updatedData.push(node.data);
      }
    });

    setExportData(updatedData)
    updateSchema(schema, updatedData)
  }

  /*  Автоматическое добавление ряда после после заполнения всех ячеек

  const onCellEditingStopped = useCallback((params: CellEditingStoppedEvent) => {

    if (params.rowPinned !== 'bottom') return;
    
    // Check all pinned row cells have a value
    if (isPinnedRowComplete()) {
      addNewStaticRow(params);
    }
  }, [pinnedRowData]);

  // Checks if all required fields in the pinned row are filled
  const isPinnedRowComplete = () => {
    let cols = JSON.parse(JSON.stringify(colDefs))
    cols.shift() // убираем первый элемент из массива, который не несет дынных (кнопка удаления)

    return cols.every((colDef) => {
      if (!colDef.field) return false;
      const v = pinnedRowData[colDef.field];
      return v != null && v !== '';
    });
  };
  */

  const addNewStaticRow = (params) => {
    // Add the new row to the grid data

    params.api.applyTransaction({ add: [params.data] });

    //let newExportData = loadExportData(schema, data);
    //newExportData.push(pinnedRowData)

    const updatedData = [];
    params.api.forEachNode((node) => {
      if (node.data) {
        updatedData.push(node.data);
      }
    });

    setExportData(updatedData);
    updateSchema(schema, updatedData);
    // Reset the input row for next entry
    setPinnedRowData({'eas_static_row': true, 'ais_upload': true, 'name': "—"});

    // Sroll table down to the new row
    const lastRowIndex = params.api.getDisplayedRowCount() - 1; 
    params.api.ensureIndexVisible(lastRowIndex, 'bottom');
  };


  const deleteStaticOrExportRow = (params) => {

    params.api.applyTransaction({ remove: [params.data] });
    
    // Получаем обновленные данные после удаления строки
    const updatedData = [];
    params.api.forEachNode((node) => {
      if (node.data) {
        updatedData.push(node.data);
      }
    });
    
    // Обновляем exportData и схему
    setExportData(updatedData);
    updateSchema(schema, updatedData);
  }
  
  const updateSchema = useCallback((schema, data) => {

    setIsDirty(true)
    
    const newSchema = generateSchemafromTable(schema, data)
    
    setSchema(newSchema)

  }, [generateSchemafromTable, setSchema, setData ])


  return (
    <div className="m-0 p-0"  >
      <div className="" style={{ height: "80vh", width: "100%" }}>
        <AgGridReact
          rowData={exportData}
          columnDefs={colDefs}
          defaultColDef={{
            sortable: true,
            filter: true,
            resizable: true
          }}
          localeText={AG_GRID_LOCALE_RU}
          onCellValueChanged={()=> updateSchema(schema, exportData)}
          suppressScrollOnNewData={true}
          rowClassRules={rowClassRules}
            // Pin an empty row at the top for data entry
          pinnedBottomRowData={[pinnedRowData]} 
            // Listen for pinned row edits
          // onCellEditingStopped={onCellEditingStopped} 
        />
      </div>
    </div>
  )
}


export default ExportTab